export const input: any = {
  px: 'sm',
  py: 'xxsm',
  mb: 'none',
  ml: 'none',
  fontSize: 'lg',
  p: 'xss',
  color: 'primaryLight',
  border: 'light',
  outline: 'none',
  boxSizing: 'border-box',
  css: ({ invalid, theme }: any) => ({
    '::placeholder': {
      color: theme.colors.secondary
    },
    borderRadius: '4px',
    border: '1px solid #C1C8D0',
    borderColor: invalid ? theme.colors.error : theme.colors.primaryLight,
    resize: 'vertical',
    ':focus': {
      color: theme.colors.primaryText,
      borderColor: invalid ? theme.colors.error : theme.colors.secondaryLight,
      background: theme.colors.secondaryLighter,
      boxShadow: '0 0 0 2px #dad8f6'
    },
    ':focus-visible': {
      outline: 'none',
      boxShadow: '0 0 0 2px #dad8f6'
    },
    ':disabled': {
      '::placeholder': {
        color: theme.colors.secondary
      },
      color: theme.colors.secondaryText,
      background: theme.colors.lightGray,
      borderColor: theme.colors.secondaryDark,
      cursor: 'not-allowed'
    },
    ':invalid': {
      boxShadow: 'none'
    },

    fontFamily: 'inherit',
    lineHeight: 'inherit',
    WebkitAppearance: 'none',
    appearance: 'none',
    width: '100%'
  })
};
